import { render, staticRenderFns } from "./CourseMassEditSlidebar.vue?vue&type=template&id=df7ccc46"
import script from "./CourseMassEditSlidebar.vue?vue&type=script&lang=js"
export * from "./CourseMassEditSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports